import { Link, useParams } from 'react-router-dom';
import methods from '../../services/utility';
// assets
import back from "../../assets/images/icons/arrow-right2.svg";
import UnderConstruction from '../public/underConstruction/UnderConstruction';

const Accounting = () => {
  const { branchId } = useParams();
  return (
    <main className="col-md-9 col-lg-10 p-md-5 mx-md-auto vh-100">
      <div className='d-none d-lg-flex justify-content-start align-items-baseline mb-3'>
        <Link to={`/sale/${branchId}`} className='link back-link'>
          <span><img src={back} className="" alt="return" /></span>
          بازگشت
        </Link>
      </div>
      <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
        <div className='d-md-flex justify-content-between align-items-baseline'>
          <Link to={`/sale/${branchId}`} className='link back-link'>
            <span><img src={back} className="" alt="return" /></span>
          </Link>
          حسابداری
        </div>
        <p className="date">{methods.currentDate()}</p>
      </div>
      <div className='saleheader d-none d-lg-block'>
        <p>حسابداری</p>
      </div>
      <UnderConstruction />
    </main>
  );
}

export default Accounting;